import {
  getMirrorNodeAttrs,
  reactive,
} from '@ps/store/workbench/game/mirror-node'
import Vue from 'vue'
import store from '@ps/store'
import { filter } from '@ps/bridge/qc/node/utils'
import lockEdit from './lock-edit'
import box2d from './box2d'
import text from './text'
import node from './node'

/**
 * 获取新的节点列表
 * @param uuids 当前节点列表
 */
const getNodesUseUuid = (uuids, root) => {
  if (!uuids) return
  return filter(root, (item) => uuids.some((j) => j === item.uuid))
}

export default {
  ...node,
  ...text,
  ...lockEdit,
  ...box2d,

  /**
   * 选中节点
   * @param uuid 选中节点 id
   * @param uuids 选中节点 id 列表
   */
  selectNode(state, { uuid = '', uuids = [] } = {}) {
    const activeNodeList = getNodesUseUuid(uuids, state.UIRoot) || []
    const node = activeNodeList.find((item) => item.uuid === uuid)
    if (node) {
      state.activeNodeList = activeNodeList
      state.activeNode = reactive(node, (key, value) => {
        if (state.mirrorNode) {
          Vue.set(state.mirrorNode, key, value)
        } else {
          console.log('找不到 mirrorNode', state.activeNode, state.mirrorNode)
        }
      })
      state.mirrorNode = getMirrorNodeAttrs(state.activeNode)
      store.commit('workspace/rightPane/switchToNodeConfigTab')
    } else {
      // 当没有找到在当前激活节点上找到当前节点时，则重置
      state.activeNodeList = []
      state.activeNode = null
      state.mirrorNode = null
      store.dispatch('workspace/rightPane/switchToStageConfigTab')
    }
  },

  // 添加skPlayer
  playFirstAnimation(state) {
    if (typeof state.activeNode.animationNameList !== 'undefined') {
      // 原来默认第一个动作为默认动作，现在有了skPlayer后不用了
      // state.activeNode.defaultAnimation = state.activeNode.animationNameList[0]
      state.activeNode.addScript('ps.SKPlayer')
    }
  },
  // 2d玩法组件添加弹出动画提示
  updateFirstComponentTip(state, value) {
    state.firstComponentTip = value
  },
}
